import React from 'react';
import {
  makeStyles,
  shorthands,
  Button,
  Card,
  CardHeader,
  Text,
  Divider,
  Body1,
} from '@fluentui/react-components';
import { ShieldCheckmarkRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  loginCard: {
    maxWidth: '500px',
    margin: '100px auto',
    ...shorthands.padding('30px'),
    textAlign: 'center',
  },
});

function LoginCard({ onLogin }) {
  const classes = useStyles();

  return (
    <Card className={classes.loginCard}>
      <CardHeader
        image={<ShieldCheckmarkRegular fontSize={48} />}
        header={<Text weight="semibold" size={500}>Authentication Required</Text>}
        description={<Body1>Please sign in with your Microsoft account to access the API testing tool</Body1>}
      />
      <Divider style={{ margin: '20px 0' }} />
      <Button
        appearance="primary"
        size="large"
        onClick={onLogin}
      >
        Sign in with Microsoft Account
      </Button>
    </Card>
  );
}

export default LoginCard;